import React, {useContext} from "react";
import {useTranslation} from "react-i18next";
import {RegionSelectedContext} from "../../contexts/RegionSelectedContext";
import styled from "styled-components";

interface Props {
  isLight?: boolean
}

const LegendComponent: React.FC<Props> = ({isLight}) => {
    const { t } = useTranslation();

    const { yearSelected } = useContext(RegionSelectedContext);
    const { year } = yearSelected;

    return(
        <LineMeaningContainer>
            <div className={'line-row'}>
                <ColorBox color={ isLight ? '#8b8b8b' : '#FFFFFF'}/>
                <div className={'legend-title'}>
                    { t(
                        `marketAnalysis.${yearSelected.niiff ? "niif." : ""}barChart.legend.last10Years`, 
                        { year: year - 10 }
                        ) 
                    }
                </div>
            </div>

            <div className={'line-row'}>
                <ColorBox color={'#464646'}/>
                <div className={'legend-title'}>
                    { t(`marketAnalysis.${yearSelected.niiff ? "niif." : ""}barChart.legend.incrementLast9Years`, { yearStart: year - 10, yearEnd: year - 1 }) }
                </div>
            </div>
            <div className={'line-row'}>
                <ColorBox color={'#FAA3A3'}/>
                <div className={'legend-title'}>
                    { t(`marketAnalysis.${yearSelected.niiff ? "niif." : ""}barChart.legend.incrementLast9Years`, { yearStart: year - 1, yearEnd: year }) }
                </div>
            </div>
            <div className={'line-row'}>
                <BiColorBox color={'#CC0000'}/>
                <div className={'legend-title'}>
                    { t(`marketAnalysis.${yearSelected.niiff ? "niif." : ""}barChart.legend.last10Years`, { year: year }) }
                </div>
            </div>
        </LineMeaningContainer>
    )
};
const ColorBox = styled.div`
    height: 0.7rem;
    min-height: 0.7rem;
    width: 0.7rem;
    min-width: 0.7rem;
    background-color: ${(props: {color: string}) => props.color };
    border-radius: 2px;
`;

const BiColorBox = styled.div`
    border-width: 2px;
    border: solid ${(props: {color: string}) => props.color };
    height: 0.7rem;
    min-height: 0.7rem;
    width: 0.7rem;
    min-width: 0.7rem;
    background-color: white;
    border-radius: 0.7rem;
`;

const LineMeaningContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex: 0 0 auto;
    font-family: MapfreText-Light;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    flex-wrap: wrap;

    .line-row {
        display: flex;
        flex-direction: row;
        flex: 1 0 0;
        align-items: center;
        margin-left: 5px;
        margin-right: 5px;
    }

    .legend-title {
        margin-left: 10px;
    }

    @media (max-width: 480px) {
      font-size: 0.7rem;
    }
`;

export default LegendComponent;
